import React, { Component } from 'react'
import './game.css'
import { get } from '../../ajax/tools'
import PopUp from '../round/PopUp'

class GGAddPeople extends Component {
  constructor(props) {
    super(props)
    this.state = {
      AddPeopleId: '', //输入的添加人员ID或身份证号
      MyGroupPeoArr: [], //所属本机构的人员数据
      highlightIndex: -1, // 高亮显示
    }
  }

  componentDidMount = function () {
    get({ url: 'match/query_school_stu' }).then((res) => {
      if (res.errno === '200') {
        this.setState({
          MyGroupPeoArr: res.data,
        })
      } else {
        this.setState({
          PopUp: '提示弹窗',
          MessageTip: res.errmsg + '！',
        })
      }
    })
  }

  //输入ID或身份证号
  AddPeopleId(event) {
    event.target.value = event.target.value.replace(/[\u4E00-\u9FA5]/g, '')
    this.setState({
      AddPeopleId: event.target.value,
    })
  }

  //点击搜索ID
  GGAPSearchBtn() {
    let AddPeopleId = this.state.AddPeopleId
    let MyGroupPeoArr = this.state.MyGroupPeoArr

    if (AddPeopleId !== '') {
      get({ url: 'reuse/get_personal_info/' + AddPeopleId }).then((res) => {
        if (res.errno === '200') {
          const searchResult = res.data[0]
          const existingIndex = MyGroupPeoArr.findIndex(
            (item) => item.yy_num === searchResult.yy_num
          )

          if (existingIndex !== -1) {
            // 已存在移到第一位
            const [existingItem] = MyGroupPeoArr.splice(existingIndex, 1)
            MyGroupPeoArr.unshift(existingItem)
          } else {
            // 添加到第一位
            MyGroupPeoArr.unshift(searchResult)
          }

          this.setState({
            MyGroupPeoArr: MyGroupPeoArr,
            AddPeopleId: '',
            highlightIndex: 0,
          })

          setTimeout(() => {
            this.setState({ highlightIndex: -1 })
          }, 3000)
        } else {
          this.setState({
            PopUp: '提示弹窗',
            MessageTip: res.errmsg + '！',
          })
        }
      })
    } else {
      this.setState({
        PopUp: '提示弹窗',
        MessageTip: '请输入人员ID或身份证号！',
      })
    }
  }

  //添加人员按钮
  GGAPListMainBtn(item, index) {
    this.props.GGAddPeople(item)
  }

  //提示弹窗
  ChildBackTip = (event) => {
    if (event === 'CrossOut') {
      this.setState({
        PopUp: '',
      })
    }
  }

  render() {
    return (
      <div className={'GGAddPeopleBox'}>
        <div className={'GGAPSearchBox clearfix'}>
          <div className={'GGAPSearchTit'}>人员ID</div>
          <div className={'GGAPSearchMainBox'}>
            <input
              className={'GGAPSearchInput'}
              type={'text'}
              name={'AddPeopleId'}
              value={this.state.AddPeopleId}
              onChange={this.AddPeopleId.bind(this)}
              placeholder={'输入人员的ID号搜索以添加'}
              autoComplete={'off'}
            />
            <div
              className={'GGAPSearchBtn'}
              onClick={this.GGAPSearchBtn.bind(this)}
            >
              搜索
            </div>
          </div>
          <div className={'GGAPSearchDescription'}>
            *请输入参赛人员ID进行搜索，结果为下方列表置顶
          </div>
        </div>
        <div className={'GGAPListTitleBox clearfix'}>
          <div className={'GGAPListTitleName'}>人员姓名</div>
          <div className={'GGAPListTitleName'}>人员ID</div>
        </div>
        <div className={'GGAPBorder'}> </div>
        <div className={'GGAPListMainBox scrollBar'}>
          {this.state.MyGroupPeoArr.map((item, index) => (
            <div
              className={'GGAPListMainList clearfix'}
              key={index}
              style={{
                backgroundColor:
                  this.state.highlightIndex === index
                    ? '#e6f7ff'
                    : 'transparent',
                border:
                  this.state.highlightIndex === index
                    ? '1px solid #1890ff'
                    : 'none',
                borderRadius: '4px',
                padding: '4px 0',
                transition: 'all 0.3s ease',
              }}
            >
              <div className={'GGAPListMainListContent'}>{item.real_name}</div>
              <div className={'GGAPListMainListContent'}>{item.yy_num}</div>
              <div className={'GGAPListMainListContent'}>
                <div
                  className={'GGAPListMainBtn'}
                  onClick={() => this.GGAPListMainBtn(item, index)}
                >
                  报名
                </div>
              </div>
            </div>
          ))}
        </div>
        {this.state.PopUp === '提示弹窗' && (
          <PopUp
            ChildBackClick={this.ChildBackTip.bind(this)}
            type={'提示'}
            message={this.state.MessageTip}
            OutButton={'Yes'}
          />
        )}
      </div>
    )
  }
}

export default GGAddPeople
